import axios from 'axios';

export default class S3Api {
    getFile = (url) =>
        axios.get(url, { responseType: 'arraybuffer', responseEncoding: 'gzip' }).then((res) => {
            if (res && res.data) {
                return res.data;
            }
            return null;
        });

    uploadFile = (url, data) =>
        axios.put(url, data, { 'Content-Type': 'application/x-www-form-urlencoded' });
}
